import { Injectable, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { BasketErrorModalComponent } from '../../basket-error-modal/basket-error-modal.component';
import { BasketModalComponent } from '../../basket-modal/basket-modal.component';
import { InfoModalComponent } from '../../info-modal/info-modal.component';
import { MTicketInfoModalComponent } from '../../info-modal/m-ticket-info-modal/m-ticket-info-modal.component';
import { MapModalComponent } from '../../map-modal/map-modal.component';
import { InfoModalInterface, MapModalInterface } from '../../models';
import { RewardsModalComponent } from '../../rewards-modal/rewards-modal.component';

@Injectable({
  providedIn: 'root',
})
export class InfoModalService {
  constructor(
    public dialog: MatDialog,
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {}

  private basketErrorShowing = false;

  deliveryTabMTicket() {
    this.dialog.open(MTicketInfoModalComponent, {});
  }

  deliveryTabSwift() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('delivery_swift_title', {
          ns: 'translation',
        }),
        markdown: 'delivery_swift_markdown',
        showTicket: false,
      },
    });
  }

  ticketSelector(data: InfoModalInterface) {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t(data.title, {
          ns: 'translation',
        }),
        markdown: data.markdown,
        showTicket: false,
      },
    });
  }

  ticketType1Week() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('ticket_type_one_week', {
          ns: 'translation',
        }),
        markdown: 'ticket_type_modal_1_week_adult_markdown',
        showTicket: true,
      },
    });
  }

  ticketType4Week() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('ticket_type_four_week', {
          ns: 'translation',
        }),
        markdown: 'ticket_type_modal_4_week_adult_markdown',
        showTicket: true,
      },
    });
  }

  ticketType13Week() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('ticket_type_thirteen_week', {
          ns: 'translation',
        }),
        markdown: 'ticket_type_modal_13_week_adult_markdown',
        showTicket: true,
      },
    });
  }

  photoIdGuidelines() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('photo_upload_guidelines_title', {
          ns: 'translation',
        }),
        markdown: 'photo_upload_guidelines_markdown',
      },
    });
  }

  photoIdTooLargeGuidelines() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('photo_upload_too_large_title', {
          ns: 'translation',
        }),
        markdown: 'photo_upload_too_large_markdown',
      },
    });
  }

  ticketSelectorMap(data: MapModalInterface) {
    this.dialog.open(MapModalComponent, {
      data,
      panelClass: ['nx-modal', 'map-modal'],
    });
  }

  rewardsModal() {
    this.dialog.open(RewardsModalComponent);
  }

  basket() {
    this.dialog.open(BasketModalComponent);
  }

  basketError(data: { canRetry: boolean; errorText: string }) {
    if (!this.basketErrorShowing) {
      this.basketErrorShowing = true;
      this.dialog
        .open(BasketErrorModalComponent, {
          data: {
            canRetry: data.canRetry,
            errorText: data.errorText,
          },
        })
        .afterClosed()
        .subscribe(() => {
          this.basketErrorShowing = false;
        });
    }
  }

  closeAllDialogs = () => {
    this.dialog.closeAll();
  };
}
